import * as React from "react";
import { WizardState, WizardActionTypes } from '../Execution/CorrectionTypes/WizardTypings';

export const useWizard = () => {
    const initialState: WizardState = { page: 0 };

    const reducer = (state: WizardState, action: WizardActionTypes): WizardState => {
        switch (action) {
            case WizardActionTypes.Next:
                return {
                    ...state,
                    page: state.page + 1
                };
            case WizardActionTypes.Previous:
                return {
                    ...state,
                    page: state.page - 1
                };
            case WizardActionTypes.Reset:
                return initialState;
            default:
                throw new Error("Unexpected action");
        }
    };

    const [currentState, dispatch] = React.useReducer(reducer, initialState);

    return { currentState, dispatch };
}
